import RedBeacon from './RedBeacon.component';

export default RedBeacon;